import React from "react";
import Routes from "./Routes";
import './styles/skins.css';
import './styles/mobile.css';

function App() {
  return <Routes />;
}

export default App;
